import { FirebaseApp, FirebaseOptions, initializeApp } from "firebase/app";

export let site_wide_firebaseapp: FirebaseApp;

export function initFirestore() {
    // Import the functions you need from the SDKs you need
    // TODO: Add SDKs for Firebase products that you want to use
    // https://firebase.google.com/docs/web/setup#available-libraries

    // Your web app's Firebase configuration
    const firebaseConfig:FirebaseOptions = {
        apiKey: "AIzaSyAze08aVQV_nrovyhh2otmemA7aV2dcjag",
        authDomain: "breuer-stahlhandel.firebaseapp.com",
        projectId: "breuer-stahlhandel",
        storageBucket: "breuer-stahlhandel.firebasestorage.app",
        messagingSenderId: "664355044292",
        appId: "1:664355044292:web:9f0d77fb856ff833c44291",
    };

    // Initialize Firebase
    site_wide_firebaseapp = initializeApp(firebaseConfig);
}